export default "__VITE_ASSET__DtZcVcvp__"